import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseSearch,
  basePost,
  basePatch,
  baseDelete
} from 'services/base-services/baseService';

const baseURL = `${API2_HOST}/sm-sub-skills`;
const search = async request => {
  return await baseSearch(baseURL, request);
};

const post = async request => {
  return await basePost(baseURL, request);
};
const patch = async (id, request) => {
  return await basePatch(baseURL, request, id);
};

const deleteSubSkill = async id => {
  return await baseDelete(baseURL, id);
};

export { search, post, patch, deleteSubSkill };
